<template>
  <div class="w-full" ref="dropdownContainer">
    <!-- For larger viewports -->
    <div class="hidden sm:flex sm:flex-wrap sm:space-x-1 mx-0 mt-1">
      <button
        v-for="tab in visibleTabs"
        :key="tab.value"
        @click="handleTabClick(tab)"
        :class="[
          'py-0.5 px-2 rounded-md border-2 border-transparent',
          modelValue === tab.value
            ? 'bg-skin-active128 text-skin-b-invt font-semibold text-base sm:text-lg'
            : 'hover:bg-skin-b-list-head hover:text-skin-b-list-base hover:border-skin-b-list-bord font-normal text-skin-b-list-mute text-xs sm:text-base'
        ]"
        class="cursor-pointer focus:outline-none"
      >
        {{ tab.name }}
      </button>
    </div>

    <!-- For smaller viewports -->
    <div class="relative sm:hidden mx-0 mt-1 w-full bg-red-100">
      <button
        @click="toggleDropdown"
        class="py-1 px-3 bg-skin-active128 text-skin-b-invt font-semibold text-base rounded-md focus:outline-none flex justify-between items-center w-full"
      >
        {{ selectedTab.name || 'Select a Tab' }}
        <span class="ml-2">▼</span>
      </button>
      <!-- Dropdown with teleport -->
      <teleport to="body">
        <ul
          v-if="dropdownOpen"
          class="absolute mt-1 bg-white border border-gray-300 rounded-md shadow-md w-full left-0 right-0 z-50"
          :style="{ top: dropdownTop + 'px', left: dropdownLeft + 'px', width: dropdownWidth + 'px' }"
        >
          <li
            v-for="tab in visibleTabs"
            :key="tab.value"
            @click="handleDropdownTabClick(tab)"
            class="py-2 px-4 hover:bg-slate-300/40 cursor-pointer"
            :class="{ 'font-semibold bg-skin-active128/10': selectedTab.name === tab.name }"
          >
            {{ tab.name }}
          </li>
        </ul>
      </teleport>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dropdownOpen: false, // Tracks dropdown visibility
      dropdownTop: 0,
      dropdownLeft: 0,
      dropdownWidth: 0,
    };
  },
  computed: {
    visibleTabs() {
      return this.tabs.filter((tab) => tab.view);
    },
    selectedTab() {
      return this.visibleTabs.find((tab) => tab.value === this.modelValue) || {};
    },
  },
  methods: {
    handleTabClick(tab) {
      this.$emit('update:modelValue', tab.value);
      if (tab.onClick) {
        tab.onClick();
      }
    },
    handleDropdownTabClick(tab) {
      this.handleTabClick(tab);
      this.dropdownOpen = false; // Close dropdown after selection
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;

      if (this.dropdownOpen) {
        this.updateDropdownPosition();
      }
    },
    updateDropdownPosition() {
      const buttonRect = this.$refs.dropdownContainer.getBoundingClientRect();
      this.dropdownTop = buttonRect.bottom + window.scrollY; // Calculate position relative to viewport
      this.dropdownLeft = buttonRect.left + window.scrollX;
      this.dropdownWidth = buttonRect.width;
    },
    handleClickOutside(event) {
      if (!this.$refs.dropdownContainer.contains(event.target)) {
        this.dropdownOpen = false; // Close the dropdown
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style scoped>
/* Optional: Add styles to customize the dropdown or buttons as needed */
</style>
